<template>
  <div class="home-main">
    <div class="header">
      <img style="height:125px; width: 1170px" class="filter-img" />
      <img
        style="height:125px; width: 1170px"
        class="img-fluid home-img"
        src="img/banner.png"
        alt="home-img"
      />
    </div>
    <div class="home-content">
      <p style="font-size: 25px; margin-bottom:0;">Redução da jornada de trabalho e de salários</p>
      <div style="width:100%; margin:0;" class="bordert"></div>
    </div>
    <div style="flex-direction:column" class="inputs flex-centered">
      <div class="input">
        Salário Atual
        <money @keydown.native="$event.key === '-' ? $event.preventDefault() : null" v-model="salario" v-bind="money" />
        <i
          class="fas fa-question-circle question-icon"
          v-b-popover.hover.top="'A Medida Provisória nº 936/2020 não esclarece o conceito de salário a ser indicado no preenchimento, entedemos que deverão ser informados as importâncias fixas e variáveis'"
        ></i>
      </div>
      <div class="input">
        Percentual de Redução
        <money @keydown.native="$event.key === '-' ? $event.preventDefault() : null" v-model="percentual" v-bind="percentage" />
      </div>
      <div class="buttons">
        <button @click="limpar()" class="limpar-btn">limpar</button>
        <button @click="click()" class="calcular-btn">calcular</button>
        <b-spinner v-show="spinner" style="margin-left:15px;"></b-spinner>
        <i v-show="erro" class="fas fa-times" style="font-size: 20px;margin-left:15px; color: red;"></i>
      </div>
    </div>
    <div v-show="resultado.$id == 1" style="flex-direction:column" class="resultado flex-centered">
      <p
        style="align-self: flex-start;font-size: 25px; color:#383838; font-weight: 700; font-style:italic; margin:30px 0 0 90px;"
      >Resultado de Cálculo</p>
      <div style="width:85%; margin:10px 0 30px 0;" class="bordert"></div>
      <div class="input">
        O valor do Benefício Emergencial pago
        <strong>pela União</strong>
        <input style="border:none" v-model="resultado.valorBeneficio" />
      </div>
      <div class="input">
        O valor do salário pago pela Empresa
        <input
          style="border:none"
          v-model="resultado.valorEmpresa"
        />
      </div>
      <div class="input">
        Valor Total
        <input style="border:none" v-model="resultado.valorTotal" />
      </div>
    </div>
    <div class="flex-centered" style="flex-direction:column;">
      <div class="obs">
        <ul v-if="resultado.$id != 1">
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">O empregador doméstico poderá através de acordo individual com o seu empregado reduzir a sua jornada de trabalho e de salários,
          nos percentuais de: 25%, 50% ou 70%, por um período de até 90 dias;</li>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">O empregado doméstico receberá da União o Benefício Emergencial
          nos percentuais de redução, calculados com base no valor do seguro desemprego que ele teria direito. Neste caso, o cálculo terá como
          base sempre o salário mínimo, conforme art. 6º, da Resolução CODEFAT nº 757/2015;</li>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">Considerando que o empregado doméstico não possui
          sindicato da categoria, o empregador deverá inicialmente fazer a transmissão para o Ministério da Economia em até 10 dias da celebração
          do acordo, e aguardar outra orientação.</li>
        </ul>
        <ul v-else>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">O empregador tem prazo de 10 dias da celebração do acordo para fazer a comunicação ao Ministério da Economia através do Portal Empregador Web;</li>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">Sobre o valor do pago pelo empregador haverá a incidência de INSS e FGTS;</li>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">Não haverá desconto pelo governo em relação ao Benefício Emergencial;</li>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">Caso o valor de base de cálculo da contribuição do INSS resulte em valor inferior ao limite mínimo de contribuição, o empregado poderá complementar o recolhimento conforme inciso I, art. 29 Emenda Constitucional nº 103/2019.</li>
        </ul>
      </div>
      <button @click="$router.push('home')" class="voltar-btn">voltar</button>
    </div>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50;
    },
    click() {
      if (this.salario == 0) {
        this.erro = true;
      } else {
        this.calcular();
      }
    },
    async calcular() {
      this.erro = false;
      this.spinner = true;
      this.resultado = await api.getReducaoD(
        this.salario,
        this.percentual,
        true
      );
      this.spinner = false;
    },
    limpar() {
      this.salario = 0;
      this.percentual = 0;
      this.resultado = [];
      this.spinner = false;
      this.erro = false;
    }
  },
  computed: {},
  watch: {},
  data() {
    return {
      salario: 0,
      percentual: 0,
      scrolled: false,
      usuario: "",
      faturamento: false,
      resultado: [],
      spinner: false,
      erro: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: false
      },
      percentage: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " %",
        precision: 2,
        masked: false
      }
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  async beforeCreate() {}
};
</script>

<style>
* {
  font-family: "Segoe UI";
}
</style>